import React, { FC } from "react";
import RadioActive from "../../../../../../assets/icon/RadioActive";
import Radio from "../../../../../../assets/icon/Radio";

type Props = {
  isMetadataActive?: boolean;
  isRadioActice?: boolean;
  onClick?: () => void;
};

const EfirControl: FC<Props> = ({ isMetadataActive, isRadioActice }) => {
  return (
    <>
      {isMetadataActive && isRadioActice ? (
        <div className="flex items-center pl-5">
          <RadioActive />
          <span className="pl-2 text-green">Зараз в ефірі</span>
        </div>
      ) : (
        <div className="flex items-center pl-5">
          <Radio />
          <span className="pl-2">До ефіру</span>
        </div>
      )}
    </>
  );
};

export default EfirControl;
